<template>
  <b-col sm="12" :lg="lgSize" :offset-lg="lgOffset">
    <div class="animated fadeIn">
      <b-modal
        title="Choose period"
        class="modal-primary"
        v-model="modalDate"
        @ok="fetchData(), (modalDate = false)"
      >
        <b-form>
          <b-form-group label="From" label-for="date" :label-cols="3">
            <datepicker use-utc
              format="yyyy-MM-dd"
              :bootstrap-styling="true"
              v-model="dateFrom"
              name="dateFrom"
            ></datepicker>
          </b-form-group>
          <b-form-group label="To" label-for="dateTo" :label-cols="3">
            <datepicker use-utc
              format="yyyy-MM-dd"
              :bootstrap-styling="true"
              v-model="dateTo"
              name="dateTo"
            ></datepicker>
          </b-form-group>
        </b-form>
      </b-modal>

      <b-card class="backClass" header="Received">
        <div slot="header">
          <h5 style="display: inline;" class="card-title mb-0">
            Delivered - {{ title }}
            <small style="font-weight:600; color:#20a8d8">
              {{ from ? from : dateFrom }}
              <b>|</b>
              {{ to ? to : dateTo }}
            </small>
          </h5>
          <div class="card-header-actions">
            <b-button
              class="btn"
              style="height: 26px; width: 26px"
              variant="transparent p-0"
              attr="pdf"
              @click="downloadPDF()"
            >
              <i
                class="fa fa-file-pdf-o"
                style="color: rgb(32, 168, 216);"
                aria-hidden="true"
              ></i>
            </b-button>
            <b-button
              @click="modalDateEvent"
              class
              style="height: 26px; width: 26px"
              variant="transparent p-0"
            >
              <i class="icon-calendar" style="color: #20a8d8;"></i>
            </b-button>
            <b-button
              @click="toggleFullScreen"
              style="height: 26px; width: 26px"
              class="float-right"
              variant="transparent p-0"
              right
            >
              <i style="color: #20a8d8;" class="icon-frame"></i>
            </b-button>
          </div>
        </div>
        <div class="chart-wrapper">
          <LoadingCard v-if="loadingData"></LoadingCard>
          <highcharts
            ref="backRef"
            v-else
            :options="chartOptions"
            class="chart"
            :constructor-type="'chart'"
          ></highcharts>
        </div>
        <div v-if="locParam" slot="footer">
          <b-button
            :disabled="!showAll"
            class="btn-outline"
            variant="outline-primary"
            left
            @click="(showAll = false), fetchData()"
            >Top 10</b-button
          >
          <b-button
            :disabled="showAll"
            class="btn-outline float-right"
            variant="outline-primary"
            right
            @click="(showAll = true), fetchData()"
            >All Data</b-button
          >
          <b-button
            class="btn-outline text"
            v-if="isCelia"
            style="margin-right:10px; float:right"
            variant="outline-primary"
            @click="
              () =>
                $router.push(
                  '/base/TableAllData?type=delivered&date_from=' +
                    (from ? from : dateFrom) +
                    '&date_to=' +
                    (to ? to : dateTo)
                )
            "
            >Overall Data</b-button
          >
        </div>
      </b-card>
    </div>
  </b-col>
</template>

<script>
import { Chart } from "highcharts-vue";
import router from "../../router";
import Datepicker from "vuejs-datepicker";
import { Switch as cSwitch } from "@coreui/vue";
import LoadingCard from "../shared/LoadingCard.vue";

export default {
  name: "DeliveredCompanyProfile",
  components: {
    router,
    highcharts: Chart,
    Datepicker,
    cSwitch,
    LoadingCard
  },
  props: ["lgSize", "lgOffset", "locParam", "idCity", "title", "dFrom", "dTo"],
  data: function() {
    return {
      fullscreen: false,
      loadingData: false,
      showAll: false,
      modalDate: false,
      valueQuantity: false,
      isCelia: false,
      selected: "All",
      options: [
        { item: "All", name: "All" },
        { item: "XM2", name: "XM2" },
        { item: "XM3", name: "XM3" }
      ],
      dateName: "",
      dateFrom: "",
      company: "",
      dateTo: "",
      locationName: "",
      productGroup: "",
      locationsIds: "",
      chartOptions: {
        chart: {
          type: "column",
          backgroundColor: "transparent",
          events: {}
        },
        exporting: {
          enabled: true
        },
        title: {
          text: "",
          style: {
            color: "white",
            display: ""
          }
        },
        subtitle: {
          text: "",
          style: {
            color: "white",
            display: "none"
          }
        },
        xAxis: {
          type: "category",
          labels: {
            style: {
              color: "white"
            }
          }
        },
        yAxis: {
          title: {
            text: "Percentage Of Total"
          }
        },
        legend: {
          enabled: false
        },
        tooltip: {
          headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
          pointFormat:
            "<span >{point.name}</span>: <b>{point.y:.2f}%</b> of total<br/>"
        },
        plotOptions: {
          series: {
            dataLabels: {
              enabled: false,
              format: "{point.name}: {point.y:.1f}%",
              color: "white",
              style: {
                textOutline: false
              }
            },
            point: {
              events: {
                click: () => {}
              }
            }
          }
        },
        drilldown: {
          activeAxisLabelStyle: {
            textDecoration: "none",
            color: "white"
          },
          activeDataLabelStyle: {
            color: "white"
          }
        },
        series: [
          {
            name: "Locations",
            colorByPoint: true,
            data: null
          }
        ]
      }
    };
  },
  watch: {
    valueQuantity() {
      this.fetchData();
      if (this.fullScreen) {
        this.$refs.backRef.chart.options.chart.height = "50%";
      } else {
        this.$refs.backRef.chart.options.chart.height = 400;
      }
    }
  },
  methods: {
    detailView() {
      this.$emit("detailViewShip");
    },
    toggleFullScreen() {
      this.$fullscreen.toggle(this.$el.querySelector(".backClass"), {
        wrap: false,
        callback: this.fullscreenChange
      });
    },
    fullscreenChange(fullscreen) {
      this.fullscreen = fullscreen;
      if (this.fullscreen) {
        this.$refs.backRef.chart.options.chart.height = "50%";
      } else {
        this.$refs.backRef.chart.options.chart.height = 400;
      }
      this.$refs.backRef.chart.reflow();
    },
    fetchData() {
      this.loadingData = true;
      let params = {};
      let finType = "Fin";
      if (!this.valueQuantity || this.valueQuantity == "false") {
        finType = "Qty";
      }
      params = {
        type: this.selected,
        date_from: this.dateFrom,
        date_to: this.dateTo,
        company: this.company,
        chartType: "company"
      };
      this.$http.get("api/teleste/company/chart_profile.php", { params }).then(
        res => {
          if (!this.showAll) {
            let tmp = res.data.upData;
            tmp.sort((a, b) =>
              parseFloat(a.locationTotal) > parseFloat(b.locationTotal) ? -1 : 1
            );

            let newArr = tmp.slice(0, 10);
            if (this.locParam !== 0) {
              this.chartOptions.series[0].data = newArr;
            }
          } else {
            let tmp = res.data.upData;
            tmp.sort((a, b) =>
              parseFloat(a.locationTotal) > parseFloat(b.locationTotal) ? -1 : 1
            );
            this.chartOptions.series[0].data = tmp;
          }
          if (finType == "Fin") {
            this.chartOptions.title.text =
              "Total : $" +
              res.data.totals
                .toFixed(2)
                .replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,");
          } else {
            this.chartOptions.title.text = "Total units: " + res.data.totals;
          }

          this.loadingData = false;
          setTimeout(() => {
            this.changeHeight();
          });
        },
        err => {
          this.loadingData = false;
          console.log(err);
        }
      );
    },
    changeHeight() {
      if (this.fullscreen) {
        this.$refs.backRef.chart.options.chart.height = "50%";
      } else {
        if(this.$refs && this.$refs.backRef && this.$refs.backRef.chart && this.$refs.backRef.chart.options) {
          this.$refs.backRef.chart.options.chart.height = 400;
        }
      }
      this.$refs.backRef.chart.reflow();
    },
    modalDateEvent() {
      if (this.fullScreen) {
        this.toggleFullScreen();
        this.modalDate = true;
      } else {
        this.modalDate = true;
      }
    },
    downloadPDF() {
      if (this.locParam == 1) {
        this.$refs.backRef.chart.options.title.text =
          "Delivered equipment | " +
          (this.from() ? this.from() : this.dateFrom) +
          " - " +
          (this.to() ? this.to() : this.dateTo) +
          " " +
          this.locationName;
        this.$refs.backRef.chart.options.title.style.color = "black";
      } else {
        this.$refs.backRef.chart.options.title.text =
          "Delivered equipment | " + this.from()
            ? this.from()
            : this.dateFrom + " - " + this.to()
            ? this.to()
            : this.dateTo + " " + this.nameCity;
        this.$refs.backRef.chart.options.title.style.color = "black";
      }

      this.$refs.backRef.chart.options.title.style.display = "block";
      this.$refs.backRef.chart.options.drilldown.activeAxisLabelStyle.color =
        "black";

      this.$refs.backRef.chart.options.xAxis.forEach(obj => {
        obj.labels.style.color = "black";
      });

      this.$refs.backRef.chart.exportChart({
        type: "application/pdf",
        filename:
          "DeliveredEquipment-" +
          (this.from() ? this.from() : this.dateFrom) +
          "-" +
          (this.to() ? this.to() : this.dateTo)
      });

      this.$refs.backRef.chart.options.drilldown.activeAxisLabelStyle.color =
        "white";
    },
    from() {
      if (typeof this.dateFrom === "object") {
        this.dateFrom = this.dateFrom.toISOString().split("T")[0];
        return this.dateFrom;
      }
      return this.dateFrom;
    },
    to() {
      if (typeof this.dateTo === "object") {
        this.dateTo = this.dateTo.toISOString().split("T")[0];
        return this.dateTo;
      }
      return this.dateTo;
    }
  },
  mounted() {
    this.company = this.title;
    if (!localStorage.getItem("arr_user")) {
      router.push("/pages/login/");
    }
    if (localStorage.getItem("alpha_full_name") === "Celia Mijares") {
      this.isCelia = true;
    }
    if (this.locParam == 1) {
      this.locationsIds = localStorage.getItem("locations");
    } else {
      this.locationsIds = this.idCity;
    }
    this.valueQuantity = false;
    var fromDate = new Date();
    fromDate.setDate(fromDate.getDate() - 30);
  }
};
</script>

<style>
/* IE fix */
#card-chart-01,
#card-chart-02 {
  width: 100% !important;
}
.small {
  float: right !important;
}
</style>
